import React from "react";
import { ArrayField, Datagrid, FunctionField, TextField } from "react-admin";
import { Booking } from "../../types";
import { formatDisplayDateTime } from "../../utils/date";

interface CancellationInfoProps {
  record?: Booking;
}

const CancellationInfo: React.FC<CancellationInfoProps> = ({ record }) => {
  // Don't render if no cancellation data or not canceled
  if (
    !record ||
    (!record.canceled_at && !record.canceled_by && !record.cancellation_reason)
  ) {
    return null;
  }

  // Create array with single cancellation item for table display
  const cancellationData = [
    {
      id: 1,
      canceled_by: record.canceled_by?.full_name || "Unknown",
      canceled_at: record.canceled_at,
      cancellation_reason: record.cancellation_reason || "No reason provided",
      cancelation_category: record.cancelation_category?.name || "-",
    },
  ];

  const mockRecord = {
    id: "cancellation",
    cancellationData,
  };

  return (
    <div>
      <hr />
      <h2>Cancellation Information</h2>
      <ArrayField source="cancellationData" record={mockRecord}>
        <Datagrid>
          <TextField source="canceled_by" label="Canceled By" />
          <FunctionField
            label="Canceled At"
            render={(record: any) =>
              record.canceled_at
                ? formatDisplayDateTime(record.canceled_at)
                : ""
            }
          />
          <TextField
            source="cancelation_category"
            label="Category"
            emptyText="-"
          />
          <TextField source="cancellation_reason" label="Reason" />
        </Datagrid>
      </ArrayField>
    </div>
  );
};

export default CancellationInfo;
